import React, { Component } from 'react'
import axios from 'axios'
import settings from '../../../settings'
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import { Form, FormGroup, Col, FormControl, Checkbox } from 'react-bootstrap'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

axios.defaults.baseURL = settings.hostname

class AddEasyAccessForm extends Component {
    state = {
        number: '',
        unlimited_uses: true,
        door: null,
        startDate: moment().toDate(),
        endDate: moment().add(1, 'days').toDate(),
    }


    handleSubmit = (e, lockid) => {
        const start = moment(this.state.startDate).toISOString()
        const end = moment(this.state.endDate).toISOString()
        const doorId = this.props.door ? this.props.door._id : null

        this.props.allocateDoor(lockid, doorId, { target: this.state.number, unlimited_uses: this.state.unlimited_uses, timeframe: { start, end } })

        e.preventDefault()
    }

    onChange = (e) => {
        var state = Object.assign({}, this.state)

        if (e.target.name === "unlimited_uses") {
            state[e.target.name] = !this.state.unlimited_uses
        } else if (e.target.placeholder != "Starttid" && e.target.placeholder != "Sluttid") {
            state[e.target.name] = e.target.value
        }

        this.setState(state)
    }

    render() {
        const { lock, door } = this.props

        return (
            <Form horizontal onChange={e => this.onChange(e)} onSubmit={e => this.handleSubmit(e, lock._id)}>
                <style>
                    {`.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
            padding-left: 0;
            padding-right: 0; }`}
                </style>
                <FormGroup>
                    <Col sm={12}>
                        <FormControl type="text" name="number" placeholder="Telefonnummer" />
                    </Col>
                </FormGroup>
                <FormGroup>
                    <Col sm={12}>
                        <Checkbox name="unlimited_uses" defaultChecked={!this.state.unlimited_uses}>Engångsnyckel</Checkbox>
                    </Col>
                </FormGroup>

                <div style={{ display: this.state.unlimited_uses ? 'inherit' : 'none' }}>

                    Starttid <DatePicker
                        locale="sv"
                        selected={this.state.startDate}
                        onChange={(d) => this.setState({ startDate: d })}
                        showTimeSelect
                        placeholderText="Starttid"
                        dateFormat="dd LLL HH:mm"
                    /><br />
                    Sluttid <DatePicker
                        locale="sv"
                        selected={this.state.endDate}
                        onChange={(d) => this.setState({ endDate: d })}
                        showTimeSelect
                        placeholderText="Sluttid"
                        dateFormat="dd LLL HH:mm"
                    />
                </div>
                <div className="text-center" style={{ paddingTop: '10px' }}>
                    <button className="add-user-btn" type="submit">
                        Klar
          </button>
                </div>
            </Form>
        )
    }
}

export default AddEasyAccessForm
